import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-611e5104"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("去支付")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("支付选项")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("支付详情")
const _hoisted_5 = {
  style: {"width":"800px"},
  class: "mt-10"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("银行备注")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改账单")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "本次支付将通过银企直连的方式支付")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-15" }, null, -1))
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("手动付款")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("银企直连")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("备用金支付")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("现金支付")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确定")


const __default__ = {
  name: "ToPay",
};
import { ref, reactive, computed } from "vue";
import { businessCodeType } from '@/views/typeMapping/PaymentModuleUtils'
import { ElMessage, ElMessageBox } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { getNumber } from '@/utils/index'
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Api from "@/http/modules/index";
interface IpayInfo {
  company?: string;
  bank?: string;
  accountId?: number | string;
  businessCode?: string;
  purpose?: string;
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  // 批量转账接口
  "POST/pay_pool/batch_pay": batchPayApi,
  // 当前银行账户是否支持直连
  "POST/pay_pool/directed": directedApi,
  // 修改备注
  "PATCH/pay_pool/update_note": updateNoteApi,
  // 修改账单
  'POST/pay_pool/send_msg': send_msgApi,
} = Api;

const store = useStore();
const router = useRouter();
const dialogVisible = ref(false);

const suport_pay_direct = ref(true);
const noteVisible = ref(false);
const payAgain = ref(false);
let payInfo: any = ref<IpayInfo>({
  company: '',
  bank: '',
  accountId: '',
  businessCode: '',
  purpose: '',
});
let bankList = ref<{bankName: string}[]>([]);
let bankAccountNameList = ref<{accountId: string, accountName: string, balance: number}[]>([]);
const ruleFormRef = ref<FormInstance>();
const rules = reactive<FormRules>({
  company: [{ required: true, message: "请选择付款单位", trigger: "change" }],
  bank: [{ required: true, message: "请选择付款银行", trigger: "change" }],
  accountId: [{ required: true, message: "请选择付款账号", trigger: "change" }],
  businessCode: [{ required: true, message: "请选择付款类型", trigger: "change" }],
});
// 业务类型下拉
let businessOption = computed(() => {
  return businessCodeType(payInfo.value.bank)
})


const backPreviousPage = () => {
  router.back();
};
const getTotal = () => {
  let sum = 0;
  if (!store.state.payData.length) return 0;
  store.state.payData.forEach((el: any) => {
    sum += el.estimateAmount;
  });
  return sum.toFixed(2)
};
const companyChange = (target: any) => {
  let res = store.state.Payment.filter((el: any) => {
    return el.company == target;
  });

  bankList.value = res[0].bankList || [];
  payInfo.value.bank = "";
};
// 银行回调: 获取银行对应账户下拉
const bankChange = (target: any) => {
  let res: Array<IpayInfo> | any = bankList.value.filter((el: any) => el.bankName == target);
  // payInfo.value.accountId=res[0].accountId
  bankAccountNameList.value = res[0].accountList || [];
  payInfo.value.accountId = "";
  payInfo.value.businessCode = "";
};

// 账户回调: 展示余额
const balanceNumber = ref<any>(0)
const accountChange = (accountId: string) => {
  balanceNumber.value = bankAccountNameList.value.find(account => account.accountId === accountId)?.balance
}


const payBtnLoadong = ref(false);
const preparePay = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: boolean) => {
    if (valid) {
      payBtnLoadong.value = true;
      let { bank, accountId } = payInfo.value;
      let formdata: any = new FormData();
      formdata.append("payerCurrency", store.state.payData[0].payeeCurrency);
      formdata.append("payerBankName", bank);
      formdata.append("payerAcc", accountId);
      directedApi(formdata)
        .then((res) => {
          dialogVisible.value = true;
          let { payType } = res;
          suport_pay_direct.value = payType == 1 ? true : false;
          payBtnLoadong.value = false;
        })
        .catch((res) => {
          payBtnLoadong.value = false;
        });
    } else {
    }
  });
};
const submitPay = (payType: number | string) => {
  if (payAgain.value) return; //防抖
  payAgain.value = true;
  let amountMap: any = {};
  store.state.payData.forEach((el: any) => {
    amountMap[el.id] = el.estimateAmount;
  });
  let params = {
    businessCode: payInfo.value.businessCode.valueStr,
    totalNum: store.state.payData.length,
    totalAmt: getTotal(),
    payerCompany: payInfo.value.company,
    payerBankName: payInfo.value.bank,
    payerId: store.state.userId,
    payerCurrency: store.state.payData[0].payeeCurrency,
    payerAcc: payInfo.value.accountId,
    purpose: payInfo.value.purpose,
    amountMap: amountMap,
    payType,
  };
  batchPayApi(params)
    .then((res) => {
      dialogVisible.value = false;
      payAgain.value = false;
      router.replace("/pay/history");
    })
    .catch(() => {
      payAgain.value = false;
    });
};
const noteText = ref("");
const noteId = ref("");
const editNote = (data: any) => {
  noteText.value = data.bankNote;
  noteVisible.value = true;
  noteId.value = data.id;
};
const updateNote = () => {
  updateNoteApi({ id: noteId.value, note: noteText.value }).then(() => {
    ElMessage.success("保存成功");
    noteVisible.value = false;
    let idx = store.state.payData.findIndex((el: any) => el.id == noteId.value);
    store.state.payData[idx].bankNote = noteText.value;
  });
};
const changeBill = (data: any) => {
  let formdata = new FormData();
  formdata.append("id", data.id);
    send_msgApi(formdata as any).then((res: any) => {
      ElMessage.success("已向发起人的企业微信推送修改链接，请通知前往企业微信查看");
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      class: "mt-15",
      type: "info",
      onClick: backPreviousPage,
      icon: "ArrowLeft"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      class: "mt-15",
      type: "primary",
      loading: payBtnLoadong.value,
      disabled: payBtnLoadong.value,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (preparePay(ruleFormRef.value)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["loading", "disabled"]),
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      "label-width": "120px",
      inline: true,
      "label-position": "top",
      model: _unref(payInfo),
      rules: _unref(rules)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "付款单位:",
          prop: "company"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              placeholder: "请选项付款单位",
              modelValue: _unref(payInfo).company,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(payInfo).company) = $event)),
              onChange: companyChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.Payment, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.company,
                    label: item.company,
                    value: item.company
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "付款银行:",
          prop: "bank"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              placeholder: "请选项付款银行",
              modelValue: _unref(payInfo).bank,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(payInfo).bank) = $event)),
              onChange: bankChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bankList), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.bankName,
                    value: item.bankName
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.bankName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "付款账号:",
          prop: "accountId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              placeholder: "请选项付款账号",
              modelValue: _unref(payInfo).accountId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(payInfo).accountId) = $event)),
              onChange: accountChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bankAccountNameList), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.accountId,
                    label: item.accountName,
                    value: item.accountId
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "付款账号余额:",
          prop: "balance"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: "",
              modelValue: balanceNumber.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((balanceNumber).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "业务类型:",
          prop: "businessCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              placeholder: "请选项业务类型",
              modelValue: _unref(payInfo).businessCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(payInfo).businessCode) = $event)),
              "value-key": 'optionKey'
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(businessOption), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.label,
                    value: item.value,
                    key: item.label
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "用途(仅宁行代发):",
          prop: "purpose"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(payInfo).purpose,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(payInfo).purpose) = $event)),
              placeholder: "请输入用途",
              clearable: "",
              maxlength: "300",
              class: "form-input"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_alert, {
      title: "请注意: 用途输入框仅宁行代发工资使用",
      type: "warning",
      closable: false
    }),
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_descriptions, {
        column: 5,
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "合计笔数:" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(store).state.payData.length), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "合计金额:" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getNumber)(getTotal())), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "货币:" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(store).state.payData.length ? _unref(store).state.payData[0].payeeCurrency : "CNY"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _unref(store).state.payData,
      border: "",
      class: "mt-15"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "序号",
          width: "100px",
          prop: "no"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款人名称",
          prop: "payeeAccountName"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款银行",
          prop: "payeeBankName"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款账号",
          prop: "payeeAcc"
        }),
        _createVNode(_component_el_table_column, {
          label: "货币",
          prop: "payeeCurrency"
        }),
        _createVNode(_component_el_table_column, {
          label: "支付金额",
          prop: "estimateAmount"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              controls: false,
              modelValue: row.estimateAmount,
              "onUpdate:modelValue": ($event: any) => ((row.estimateAmount) = $event),
              placeholder: "请输入支付金额"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "银行备注",
          prop: "bankNote"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          prop: "ops"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              class: "mr-5",
              onClick: ($event: any) => (editNote(row))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (changeBill(row))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
      title: "本次支付信息",
      width: "33%",
      center: "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (submitPay(1)))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                disabled: suport_pay_direct.value || payAgain.value,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (submitPay(0)))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                disabled: !(_unref(payInfo).accountId == '备用金' && _unref(payInfo).bank == '备用金'),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (submitPay(2)))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                disabled: !(_unref(payInfo).accountId == '现金' && _unref(payInfo).bank == '现金'),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (submitPay(3)))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_8,
        _hoisted_9,
        _createVNode(_component_el_descriptions, {
          column: 1,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "付款单位:" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(payInfo).company), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "付款银行:" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(payInfo).bank), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "付款账号:" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(payInfo).accountId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "总笔数:" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(store).state.payData.length), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "总金额:" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getNumber)(getTotal())), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: noteVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((noteVisible).value = $event)),
      title: "编辑银行备注",
      width: "550"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (noteVisible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: updateNote
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: noteText.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((noteText).value = $event)),
          type: "textarea",
          rows: 4,
          maxlength: "400",
          style: {"width":"500px"},
          placeholder: "请输入银行备注"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})